// Storyblok's `meta_title` is an optional field and is frequently left empty.
// Without a fallback the layout's titleTemplate sees an empty title and
// collapses to just the brand name, so every such page ships an identical
// <title>. Fall back to the visible h1 (`content.title`) and finally to the
// story name, which Storyblok always populates.

// Walks a Storyblok rich-text document collecting its text nodes. Done by hand
// rather than via renderRichText + tag stripping so the result never contains
// HTML entities — a title going through unhead would double-escape them.
function richTextToPlainText(node) {
    if (!node)
        return ''

    if (typeof node.text === 'string')
        return node.text

    if (Array.isArray(node.content))
        return node.content.map(richTextToPlainText).join('')

    return ''
}

export default (story) => {
    const metaTitle = story.content.meta_title?.trim()

    if (metaTitle)
        return metaTitle

    const heading = typeof story.content.title === 'string'
        ? story.content.title.trim()
        : richTextToPlainText(story.content.title).trim()

    if (heading)
        return heading

    return story.name
}
